/* @jsxImportSource react */

import type { ReactNode } from 'react';

import type { LinkProps } from '../../../../Link/Link';
import { Link } from '../../../../Link/Link';
import type { SlotPriority } from './types';

export type SlotLinkProps = {
  label?: string;
  href: string;
  language?: string;
  children: ReactNode;
  priority: SlotPriority;
};

/**
 * Simplified version of the legacy Slot, for cases where the slot just needs to be a link
 *
 * @param children The icon for the slot, should be sized 32x32 pixels (w-4 h-4)
 * @param label The text label (and accessible label) for the slot
 * @param href The URL to link to
 */
export const SlotLink = ({
  label,
  href,
  language,
  children,
  priority,
  onClick,
}: SlotLinkProps & Pick<LinkProps, 'onClick'>) => (
  <Link
    href={href}
    // NOTE currently Link.locale is actually not a locale, but a language
    locale={language}
    aria-label={label}
    className={`slot-mobile-priority-${priority} slot-link hover:text-color-primary hover:after:bg-color-primary relative flex flex-col items-center py-0.5 hover:after:pointer-events-none hover:after:absolute hover:after:inset-0 hover:after:top-auto hover:after:h-[2px]`}
    onClick={onClick}
  >
    {children}
    <span className="text-size-body3 text-center hyphens-auto max-lg:hidden">{label}</span>
  </Link>
);
